module.exports = __webpack_public_path__ + "static/media/worksdeposit.0e3afb6a.png";